export default function() {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection" class="video-first"></div>');

  $(`#${widgetName}`).videoWidget({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
      , detectIpad: IPADDETECTED
      // options
      , multiVideo: false
      , showOnMobile: true
      , maxVideos: 1
      , trackingGA: {
        present: false,
        event: 'event',
        gaObj: {
          eventCategory: 'Videos',
          eventAction: '',
          eventLabel: '',
        }
      }
      , videoWidgetLoaded: function(){
        // if ($('#videoSection #youtubePlayer')[0]) {
        //   $('body').addClass('videoactive');
        // }
      }
  });

 

};
